webpackJsonp([62628483685349],{

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Webpack = __webpack_require__(24);
	
	var _Webpack2 = _interopRequireDefault(_Webpack);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Webpack2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Chunking'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Webpack defaults to putting all JavaScript files in a single ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'bundle.js'
	      ),
	      ', but the default Lore config breaks the code up into two chunks; one for ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'vendor'
	      ),
	      ' files, and one for the ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'main'
	      ),
	      ' application code.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Chunk Comparison'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you compare the output between the example ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/webpack/building/development/' },
	        'development build'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/webpack/building/production/' },
	        'production build'
	      ),
	      ', you can see that the minification and uglification process has a significant impact in the size of the final JavaScript files.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'bundle.main.js'
	      ),
	      ' file in the production build was reduced from ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '5.17 MB'
	      ),
	      'to ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '1.41 MB'
	      ),
	      ', and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'bundle.vendor.js'
	      ),
	      ' file was reduced from ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '1.04 MB'
	      ),
	      ' to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '197 kB'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'That may seem a bit unbalanced, as one file clearly has more code than the other, so feel free to adjust the packages included in each bundle to play with the sizes.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you want to experiment with the effect chunk size has on page load time, you can add and remove libraries from the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'vendor'
	      ),
	      ' chunk by modifying this section in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'webpack.config.js'
	      ),
	      ' file:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      ...\n        entry: {\n          main: \'./index.js\',\n          vendor: [\n            \'react\',\n            \'react-dom\',\n            \'react-router\'\n          ]\n        },\n      ...\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Relevant Section'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section of the Webpack config that controls this behavior is shown below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n        entry: {\n          main: \'./index.js\',\n          vendor: [\n            \'react\',\n            \'react-dom\',\n            \'react-router\'\n          ]\n        },\n        ...\n        ifProduction(new webpack.optimize.CommonsChunkPlugin({\n          names: [\n            \'vendor\'\n          ]\n        })),\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webpack-features-chunking-js-9980af3ce8fa10a11694.js